<div class="row" *ngIf="!selfServiceConfig">

    <div class="col-6" [ngClass]="(isHandset$ | async) === false ? 'col-6' : 'col-12'">
        <div class="row">
            <div class="col-6">
                <div class="dhl-Overview-section-title-v2" [ngStyle]="configData?.style">
                    {{configData.title | translate}}
                </div>
            </div>
        </div>
        <div *ngIf="configData.itemComponentList">
            <app-overview-generic-v2 *ngIf="configData.itemComponentList.generalInfo"
                [generalDetails]="configData.itemComponentList.generalInfo" [generalData]="overview">
            </app-overview-generic-v2>
            <app-overview-location-v2 *ngIf="configData.itemComponentList.locationInfo"
                [locationDetails]="configData.itemComponentList.locationInfo" [locationData]="overview">
            </app-overview-location-v2>
            <div *ngFor="let item of configData?.itemComponentList?.itemList; let i = index">
                <app-overview-item-v2 [itemDetails]="item" [itemData]="overview[item.key]" [itemList]="configData.itemComponentList.itemList"
                 [index]="i"></app-overview-item-v2>
            </div>
        </div>
        <ng-template #elseBlock>
            <div class="row">
                <div class="col-6">
                    <div class="primarySubTextLeft primarySubTextColor">
                        {{customerName}}
                    </div>
                    <div class="secondarySubTextColor font_15">
                        {{overview.orderTypeXid}}
                    </div>
                </div>
                <div class="col-6 noPaddingRght">
                    <div class="primarySubTextColor primarySubTextRight">
                        {{overview.insertDate}}
                    </div>
                    <div class="primarySubTextColor primarySubTextRight">
                        {{overview.poNumber}}
                    </div>
                </div>

                <div class="overviewSeperator"></div>
            </div>
            <div class="row">
                <div class="col-1">
                    <div class="row alignFlexCenter">
                        <div class="OvalStyle ">

                            <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1650,30,30))"
                                class="icons-and-illustrationsuser-interfacelocation">
                        </div>
                    </div>

                    <div class="row alignFlexCenter">
                        <div class="line3"></div>
                    </div>
                    <div class="row alignFlexCenter">
                        <div class="OvalStyle">

                            <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1600,30,30))"
                                class="icons-and-illustrationsuser-interfacelocation">
                        </div>
                    </div>


                </div>
                <div class="col-8">
                    <div class="margintop_12">
                        <div class="secondarySubTextColor font_15">{{overview.originId}}</div>
                        <div class="primarySubTextColor font_18"> {{overview.mapData.origin}},</div>
                        <div class="primarySubTextColor font_14">
                            {{overview.sourceLocationAddressLine}},
                            {{overview.sourceLocationCity}},
                            {{overview.sourceLocationPostalCode}},
                            {{overview.sourceLocationCountryCode}}
                        </div>
                    </div>
                    <div class="margintop_30">
                        <div class="secondarySubTextColor font_15">{{overview.destinationId}}</div>
                        <div class="primarySubTextColor font_18"> {{overview.mapData.destination}}</div>
                        <div class="primarySubTextColor font_14">
                            {{overview.destinationLocationAddressLine}},
                            {{overview.destinationLocationCity}},
                            {{overview.destinationLocationPostalCode}},
                            {{overview.destinationLocationCountryCode}}
                        </div>
                    </div>
                </div>
                <div class="col-3 primarySubTextRight">
                    <div class="margintop_12">
                        <div class="secondarySubTextColor font_12">PICKUP/DEPARTURE</div>
                        <div class="primarySubTextColor"> {{overview.earlyPickupDate}} </div>
                    </div>
                    <div class="margintop_70">
                        <div class="secondarySubTextColor font_12">DELIVERY/ARRIVAL</div>
                        <div class="primarySubTextColor"> {{overview.lateDeliveryDate}}</div>
                    </div>
                </div>
                <div class="overviewSeperator"></div>
            </div>


            <div class="row">
                <div class="col-1">
                    <!-- <img src="../../../../assets/icons/icons-truck.svg" class="iconstruck"> -->
                    <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1750,50,50))"
                        class="shipmentIcons">

                </div>
                <div class="col-11">
                    <div class="font_18 font_weight margintop_8 marginbottom_10">
                        SHIPMENT
                    </div>
                    <div *ngIf="overview.shipmentDetails.length === 0"
                        class="font_15 primarySubTextColor marginbottom_10">
                        No shipment is planned currently
                    </div>
                    <div *ngIf="overview.shipmentDetails.length > 0" class="font_15 primarySubTextColor">
                        <div *ngFor="let shipment of overview.shipmentDetails" class="marginbottom_10">
                            <div>
                                {{shipment.primary}}
                            </div>
                            <div class="shipmentDetailsColor font_14">
                                {{shipment.secondary}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overviewSeperator"></div>
            </div>
            <div class="row" *ngIf="overview.orderLines">
                <div class="col-1">

                    <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1550,50,50))"
                        class="lineitemIcons">
                </div>
                <div class="col-11">
                    <div class="font_18 font_weight margintop_8 marginbottom_10">
                        LINE ITEMS
                    </div>
                    <!-- <div *ngIf="overview.orderLines"> -->
                    <div *ngIf="overview.orderLines?.length < 0" class="font_15 primarySubTextColor marginbottom_10">
                        No line item found.
                    </div>
                    <div *ngIf="overview.orderLines?.length > 0" class="font_15 primarySubTextColor" class="col-12">
                        <div class="row marginbottom_10" *ngFor="let orderLine of overview.orderLines; let i=index;">
                            <div class="col-md-1">
                                {{i+1+'.'}}
                            </div>
                            <div class="col-md-7">
                                <div>
                                    {{orderLine.packagedItem}}
                                </div>
                                <div class="font_14 shipmentDetailsColor">
                                    <span *ngIf="orderLine.nmfcarticle !== ''">Article: {{orderLine.nmfcarticle}},</span>
                                    <span *ngIf="orderLine.nmfcclass !== ''"> Class: {{orderLine.nmfcclass}}</span>
                                </div>

                            </div>
                            <div class="col-md-2">
                                <div>
                                    {{orderLine?.packageCount}}{{orderLine?.packagingUnit?.displayValue}}
                                </div>
                                <div class="font_14 shipmentDetailsColor">
                                    {{orderLine.itemQuantity + 'items'}}
                                </div>

                            </div>
                            <div class="col-md-2">
                                <div>
                                    {{orderLine.totalWeight}}{{orderLine.weightUomCode}}
                                </div>
                                <div class="font_14 shipmentDetailsColor">
                                    {{orderLine.totalVolume}}{{orderLine.volumeUomCode}}
                                </div>
                            </div>
                            <div *ngIf="overview.orderLines.length > 1 && (i+1) < overview.orderLines.length"
                                class="overviewSeperator"></div>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
                <div class="overviewSeperator"></div>
            </div>
            <div class="row" *ngIf="overview.poLines">
                <div class="col-1">

                    <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1550,50,50))"
                        class="lineitemIcons">
                </div>
                <div class="col-11">
                    <div class="font_18 font_weight margintop_8 marginbottom_10">
                        LINE ITEMS
                    </div>
                    <div class="font_15 primarySubTextColor">
                        <div class="row marginbottom_10">
                            <div class="col-md-4">
                                {{overview.totalPackagingUnitCount}}
                            </div>
                            <div class="col-md-4">
                                {{overview.totalWeight}}
                            </div>
                        </div>
                        <div class="row marginbottom_10">
                            <div class="col-md-4">
                                {{overview.totalItemPackageCount}}
                            </div>
                            <div class="col-md-4">
                                {{overview.totalVolume}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overviewSeperator"></div>
            </div>
        </ng-template>
    </div>
    <div class="col-6" [ngClass]="(isHandset$ | async) === false ? 'col-6' : 'col-12'">
        <div *ngIf="configData?.itemComponentList?.statusInfo else elseBlock1">
            <app-overview-status-v2 [statusDetails]="configData.itemComponentList.statusInfo" [statusData]="overview">
            </app-overview-status-v2>
        </div>
        <ng-template #elseBlock1>
        <div class="statusOuter">
            <div class="row" *ngIf="overview.status.toLowerCase() === 'created'">
                <div class="col-1 statusMainImage marginleft_5p">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1510,50,50))"
                        class="iconstruck">
                    <div>Created</div>
                </div>
                <div class="col-4 progressMainDiv">
                    <div class="progress progressInnerDiv">
                        <div class="progress-bar width_70p progressActive" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
                <div class="col-1 statusMainImage centerTxtAlign ">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1660,50,50))"
                        class="iconstruck">
                    <div>Planned</div>
                </div>
                <div class="col-4 progressMainDiv">
                    <div class="progress progressInnerDiv">
                        <div class="progress-bar progressActive" role="progressbar" aria-valuenow="0" aria-valuemin="0"
                            aria-valuemax="100">
                        </div>
                    </div>
                </div>
                <div class="col-1 statusMainImage centerTxtAlign">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1710,50,50))"
                        class="iconstruck">
                    <div class="fltrght">Confirmed</div>
                </div>
            </div>
            <div class="row" *ngIf="overview.status.toLowerCase() === 'planned'">
                <div class="col-1 statusMainImage marginleft_5p">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1510,50,50))"
                        class="iconstruck">
                    <div>Created</div>
                </div>
                <div class="col-4 progressMainDiv">
                    <div class="progress progressInnerDiv">
                        <div class="progress-bar width_100p progressActive" role="progressbar" aria-valuenow="100"
                            aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
                <div class="col-1 statusMainImage centerTxtAlign ">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1560,50,50))"
                        class="iconstruck">
                    <div>Planned</div>
                </div>
                <div class="col-4 progressMainDiv">
                    <div class="progress progressInnerDiv">
                        <div class="progress-bar width_50p progressActive" role="progressbar" aria-valuenow="50"
                            aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
                <div class="col-1 statusMainImage centerTxtAlign">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1610,50,50))"
                        class="iconstruck">
                    <div class="fltrght">Confirmed</div>
                </div>
            </div>
            <div class="row" *ngIf="overview.status.toLowerCase() === 'confirmed'">
                <div class="col-1 statusMainImage marginleft_5p">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1510,50,50))"
                        class="iconstruck">
                    <div>Created</div>
                </div>
                <div class="col-4 progressMainDiv">
                    <div class="progress progressInnerDiv">
                        <div class="progress-bar width_100p progressActive" role="progressbar" aria-valuenow="100"
                            aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
                <div class="col-1 statusMainImage centerTxtAlign ">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1560,50,50))"
                        class="iconstruck">
                    <div>Planned</div>
                </div>
                <div class="col-4 progressMainDiv">
                    <div class="progress progressInnerDiv">
                        <div class="progress-bar width_100p progressActive" role="progressbar" aria-valuenow="100"
                            aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
                <div class="col-1 statusMainImage centerTxtAlign">
                    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,1460,50,50))"
                        class="iconstruck">
                    <div class="fltrght">Confirmed</div>
                </div>
            </div>
        </div>
        </ng-template>
        <div *ngIf="overview!==undefined">
            <app-here-map *ngIf="configData.mapConfig" appId="{{hereMapId}}" appCode="{{hereMapCode}}"
                [start]="overview.startMapData" [finish]="overview.finishMapData" width="100%" height="100%"
                [ConfigData]="mapConfig"></app-here-map>
        </div>

    </div>
    <!-- <div class="col-6" style="min-height:300px;" *ngIf="overview!==undefined">
        <here-map appId="{{hereMapId}}" appCode="{{hereMapCode}}" [start]="overview.startMapData"
            [finish]="overview.finishMapData" width="100%" height="100%" [ConfigData]="mapConfig"></here-map>
    </div> -->

</div>